import Navbar from "../../components/Navbar/Navbar";
import './Home.css';
import Initiatives from "../../components/Initiatives/Initiatives";
import Footer from "../../components/Footer/Footer";
import ContactForm from "../../components/ContactForm/ContactForm";
import Landing from "../../components/Landing/Landing";
import ActivitiesCarousel from "../../components/ActivitiesCarousel/ActivitiesCarousel";
import HeroSlider from "../../components/HeroSlider/HeroSlider";
import Funds from "../../components/Funds/Funds";
import BackToTop from "../../components/BackToTop/BackToTop";

export default function Home() {
    return (
        <div>
            <Navbar />
            <HeroSlider />
            <Landing />
            <ActivitiesCarousel />
            <Initiatives />
            <Funds />
            <ContactForm />
            <Footer />
            <BackToTop />
        </div>
    );
}